import {
  ApplicationConfig, ErrorHandler,
  importProvidersFrom, inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {provideRouter, withHashLocation} from '@angular/router';

import { routes } from './app.routes';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { initializeTranslation, provideTranslation } from './core/config/httpLoaderFactory';
import { GlobalErrorHandlerService } from './core/handler';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withJsonpSupport
} from '@angular/common/http';
import {LocaleService} from './core/services/locale.service';
import {localeInterceptor} from './core/interceptors/locale.interceptor';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initializeTranslation(
        inject(TranslateService),
        inject(LocaleService)
      );
      return initializerFn();
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    importProvidersFrom([TranslateModule.forRoot(provideTranslation())]),
    provideAnimationsAsync(),
    provideHttpClient(withJsonpSupport(), withInterceptorsFromDi(), withInterceptors([localeInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    importProvidersFrom(OverlayModule, PortalModule, MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule)]
};
